import React from 'react';
import { history } from '../../data/history';

import './history.css';

const History = () => {
  return (
    <main className='route history'>
      <h2>Wisby Ringaren 17s historia</h2>

      <section aria-label="Wisby Ringaren 17s historia">
      {history.map((part, i) => (
        <p key={i}>
          {part}
        </p>
      ))}
      </section>
    </main>
  )
}

export default History